import { render, staticRenderFns } from "./AttendanceAbsent.vue?vue&type=template&id=8720a360&"
import script from "./AttendanceAbsent.vue?vue&type=script&lang=js&"
export * from "./AttendanceAbsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports